export const ALL_MODULES_METADATA_REQUEST = "ALL_MODULES_METADATA_REQUEST";
export const ALL_MODULES_METADATA_SUCCESS = "ALL_MODULES_METADATA_SUCCESS";
export const ALL_MODULES_METADATA_ERROR = "ALL_MODULES_METADATA_ERROR";
export const ALL_MODULES_UPDATE_ORDER = "ALL_MODULES_UPDATE_ORDER";

export const MODULE_METADATA_REQUEST = "MODULE_METADATA_REQUEST";
export const MODULE_METADATA_SUCCESS = "MODULE_METADATA_SUCCESS";
export const MODULE_METADATA_ERROR = "MODULE_METADATA_ERROR";
